import { blockCategories } from '../categories';

export const keyCustomCode = 'custom-code-plugin__code';
export const typeCustomCode = 'custom-code';
export const commandNameCustomCode = 'custom-code:open-modal';

const options = {
    blockCustomCode: {},
    propsCustomCode: {},
    toolbarBtnCustomCode: {},
    modalTitle: 'Insert your code',
    buttonLabel: 'Save',
};

export default (editor) => {
    const { Components } = editor;
    const { toolbarBtnCustomCode } = {};
    let timedInterval;

    Components.addType('script', {
        view: {
            onRender() {
                const { model, el } = this;
                const isCC = model.closestType(typeCustomCode);
                isCC && (el.innerHTML = '');
            },
        },
    });

    Components.addType(typeCustomCode, {
        isComponent: (el) =>
            el.tagName === 'div' &&
            el?.classList?.contains('custom-code-block'),
        model: {
            defaults: {
                name: 'Custom Code',
                editable: true,
                attributes: { class: 'custom-code-block' },
                components: {
                    tagName: 'span',
                    components: {
                        type: 'textnode',
                        content: 'Insert here your custom code',
                    },
                },
            },

            init() {
                this.on(`change:${keyCustomCode}`, this.onCustomCodeChange);
                const initialCode = this.get(keyCustomCode);
                !this.components().length && this.components(initialCode);
                const toolbar = this.get('toolbar');
                const id = 'custom-code';

                if (
                    toolbarBtnCustomCode &&
                    !toolbar.filter((tlb) => tlb.id === id).length
                ) {
                    toolbar.unshift({
                        id,
                        command: commandNameCustomCode,
                        label: `<svg viewBox="0 0 24 24">
              <path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"></path>
            </svg>`,
                        ...toolbarBtnCustomCode,
                    });
                }
            },

            onCustomCodeChange() {
                this.components(this.get(keyCustomCode));
            },
        },

        view: {
            events: {
                dblclick: 'onActive',
            },

            init() {
                this.listenTo(
                    this.model.components(),
                    'add remove reset',
                    this.onComponentsChange
                );
                this.onComponentsChange();
            },

            onComponentsChange() {
                timedInterval && clearInterval(timedInterval);
                timedInterval = setTimeout(() => {
                    const { model, el } = this;
                    const content = model.get(keyCustomCode) || '';
                    let droppable = true;

                    if (content.indexOf('<script') >= 0) {
                        el.innerHTML = `<div style="pointer-events: none; padding: 10px;">
                                <svg viewBox="0 0 24 24" style="height: 30px; vertical-align: middle;">
                                    <path d="M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z"></path>
                                    </svg>
                                Custom code with <i>&lt;script&gt;</i> can't be rendered on the canvas
                                </div>`;
                        droppable = false;
                    }

                    model.set({ droppable });
                }, 0);
            },

            onActive() {
                const { model, em } = this;
                em.get('Commands').run(commandNameCustomCode, {
                    target: model,
                });
            },
        },
    });

    const { Blocks } = editor;

    Blocks.add(typeCustomCode, {
        label: 'Benutzerdefinierter Code',
        media: `
      <svg viewBox="0 0 24 24">
        <path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"></path>
      </svg>
    `,
        category: blockCategories.basic,
        activate: true,
        select: true,
        content: { type: typeCustomCode },
    });

    const appendToContent = (target, content) => {
        if (content instanceof HTMLElement) {
            target.appendChild(content);
        } else if (content) {
            target.insertAdjacentHTML('beforeend', content);
        }
    };

    // Add the custom code command
    editor.Commands.add(commandNameCustomCode, {
        keyCustomCode,
        target: null,
        codeViewer: null,

        run(editor, s) {
            const target = options.target || editor.getSelected();
            this.target = target;

            if (target?.get('editable')) {
                this.showCustomCode(target, options);
            }
        },

        stop(editor) {
            editor.Modal.close();
        },

        /**
         * Method which tells how to show the custom code
         * @param  {Component} target
         */
        showCustomCode(target) {
            const title = options.modalTitle;
            const code = target.get(keyCustomCode) || '';
            const content = this.getContent();
            editor.Modal.open({ title, content }).onceClose(() =>
                editor.stopCommand(commandNameCustomCode)
            );
            this.getCodeViewer().setContent(code);
        },
        getPreContent() {},
        getPostContent() {},

        getContent() {
            const codeViewer = this.getCodeViewer();
            const content = document.createElement('div');
            const pfx = editor.getConfig('stylePrefix');
            content.className = `${pfx}custom-code`;
            appendToContent(content, this.getPreContent());
            content.appendChild(codeViewer.getElement());
            appendToContent(content, this.getPostContent());
            appendToContent(content, this.getContentActions());
            codeViewer.refresh();
            setTimeout(() => codeViewer.focus(), 0);

            return content;
        },

        getContentActions() {
            const btn = document.createElement('button');
            btn.setAttribute('type', 'button');
            const pfx = editor.getConfig('stylePrefix');
            btn.innerHTML = options?.buttonLabel;
            btn.className = `${pfx}btn-prim ${pfx}btn-import__custom-code`;
            btn.onclick = () => this.handleSave();

            return btn;
        },

        handleSave() {
            const { target } = this;
            const code = this.getCodeViewer().getContent();
            target?.set(keyCustomCode, code);
            editor.Modal.close();
        },

        getCodeViewer() {
            if (!this.codeViewer) {
                this.codeViewer = editor.CodeManager.createViewer({
                    codeName: 'htmlmixed',
                    theme: 'hopscotch',
                    readOnly: 0,
                });
            }
            return this.codeViewer;
        },
    });
};
